<template>
    <div class="teamAdmin"> 
        <div class="show_container">
            <div class="staff_manage_head flex  align-cen">
            <div class="add_btn" v-if="!authType" @click="addteamUser">
                    <div class="add_btn_icon"></div>
                    <span>添加成员</span>
                </div>
                <div class="add_btn" v-if="!authType" style="margin-left:20px"  @click="openEditClass">
                    <div class="add_btn_icon1"></div>
                    <span>批量修改分类</span>
                </div>
                <div class="search_box mft" :style="authType ? 'marginLeft:0 !important' : ''">
                     <el-input placeholder="请输入成员姓名" v-model="search" clearable> </el-input>
                </div>
                <div class="search_box" style="margin-left:20px">
                     <el-input placeholder="请输入成员联系电话" v-model="search1" clearable> </el-input>
                     <!-- <div class="search_icon"></div> -->
                </div>
                <div class="public-btn-small flex align-cen" style="padding-left:20px">
                    <div class="public-btn-small-primary"  @click="gethisList(groupId,textActive)">搜索</div>
                    <div class="public-btn-small-text" @click="reset">重置筛选条件</div>
                </div>
            </div>
            <div class="f-h-flex2 flex">
                <div class="categories-tree">
                    <div class="public-add" @click="adTeamClass('')" v-if="!authType">
                        新建成员分类
                    </div>
                     <div class="categories-tree-item">
                        <!-- <div class="jstree-node flex align-cen" 
                        :class="-1 == textActive  ? 'treeactive': ''"
                        @click="swichTopic('',-1)"
                        >
                            <i class="jstree-icon"></i>
                            <span>未分类({{totalCount}})</span>
                        </div> -->
                        <div class="jstree-node flex align-cen" v-for="(item,index) in options" :key="item.id"
                        :class="index == textActive  ? 'treeactive': ''"
                        @click="swichTopic(item.id,index)"
                        >
                              <i class="jstree-icon"></i>
                            <div class="jstree-node-1 flex align-cen">
                                 <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                <span class="texto">{{item.name}}</span>
                                 </el-tooltip>
                                ({{item.num}})
                                </div>
                            <el-dropdown class="mft ">
                                 <span class="el-dropdown-link">
                                    <span class="el-icon-more "  v-if="item.id !='1'"></span>
                                 </span>
                                   <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="adTeamClass(item.name,item.id)">修改分类</el-dropdown-item>
                                    <el-dropdown-item @click.native="deletTeamClass(item.id)">删除</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            
                        </div>
                    </div>
                </div>
                <div class="categories-panel-dragger">

                </div>
             <div class="staff_manage_center">
                 <div class="businessList-container-table">
                          <el-table
          ref="multipleTable"
          :data="itemList"
          tooltip-effect="dark"
          style="width: 100%"
          id='mytable'
           :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          @select='onTableSelect'
          :header-cell-style="{background:'#fff',color:'#90909e',paddingBottom:'20px'}"
        >
         <el-table-column type="selection" width="55" reserve-selection v-if="authType !=1"> 
         </el-table-column>
           <el-table-column prop="userName" label="姓名" align="center">
          </el-table-column>
           <el-table-column prop="loginName" label="账号" align="center">
          </el-table-column>
           <el-table-column  label="最后操作" align="center">
            <template slot-scope="scope">
                <p>{{scope.row.loginTime || '-'}}</p>
            </template>
          </el-table-column>
          <el-table-column  label="已分配系统" align="center">
            <template slot-scope="scope">
                <p style="color:red;cursor: pointer;" @click="openSystem(scope.row)">{{scope.row.allocateNum}}</p>
            </template>
          </el-table-column>
          <el-table-column  label="权限" align="center">
             <template slot-scope="scope">
                <p :style="authType == '2' ? {height:'44px',lineHeight:'44px'}: ''">{{scope.row.isAdmin == 1 ? '超级管理员' : scope.row.isAdmin == 2 ? '管理员' : '使用者'}}</p>
            </template>
          </el-table-column>
           <el-table-column  label="操作" align="center" v-if="authType != 2">
            <template slot-scope="scope">
               <div class="acBtn" v-if="!authType">  
                <div v-if="isAdmin == 1">
                      <el-dropdown  v-if="scope.row.isAdmin == 0 || scope.row.isAdmin == 2" >
                        <el-button type="text" style="color:#0157ff"  class="el-dropdown-link">设置</el-button>
                                   <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="userSetClass(scope.row)">修改分类</el-dropdown-item>
                                    <el-dropdown-item @click.native="userSet(scope.row)">编辑成员</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                    <el-button type="text"v-else>-</el-button>
                </div>
                 <div v-if="isAdmin == 2">
                     <el-button type="text" style="color:#0157ff" v-if="scope.row.isAdmin == 0" @click.stop="userSet(scope.row)">设置</el-button> 
                    <el-button type="text"v-else>-</el-button>
                 </div>
                 <div v-if="isAdmin == 0">
                    <el-button type="text">-</el-button>
                 </div>
               </div>
               <div class="acBtn" v-if="authType == 1">
                <el-button type="text" style="color:red" @click.stop="swichYj(scope.row)">移交</el-button> 
               </div>
            </template>
           </el-table-column>
           </el-table>
           <paginaTion :total="totalCount" @sendStatus="emitFun" v-if="authType != 2"></paginaTion>
                 </div>
            </div>
            </div>
        </div>
        <!-- 已分配系统弹窗 -->
           <el-dialog
  title="已分配系统"
  :visible.sync="centerDialogVisible"
  width="50%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  >
   <div class="businessList-container-table">
    <el-table
          ref="multipleTable1"
          :data="systesList"
          tooltip-effect="dark"
          style="width: 100%"
          id='mytable'
          :header-cell-style="{background:'#fff',color:'#90909e',paddingBottom:'20px'}"
        >
         <el-table-column prop="appName" label="产品" align="center">
          </el-table-column>
           <el-table-column  label="服务开始时间" align="center">
            <template slot-scope="scope">
                <p>{{scope.row.startTime || '-'}}</p>
            </template>
          </el-table-column>
            <el-table-column  label="服务结束时间" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.endTime || '-'}}</p>
            </template>
          </el-table-column>
    </el-table>
    <paginaTion :total="totalCount1" @sendStatus="emitFun1"></paginaTion>
   </div>
           </el-dialog>
           <!-- 修改成员分类 -->
   <el-dialog
  title="批量修改分类"
  :visible.sync="centerDialogVisible1"
  width="50%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible1"
  >
      <div class="addteamUser">
        <div class="add_container">
         <div class="fai_notext_field  flex align-cen">
             <div class="fai_notext_field_label" style="line-height:40px">成员分类</div>
             <div class="addform ">
                 <el-checkbox-group v-model="checkList">
                    <el-checkbox :label="item.id" v-for="item in options1">{{item.name}}</el-checkbox>
                </el-checkbox-group>
             </div>
         </div>
         <div class="btm_btn_box flex align-cen">
            <div class="fai_submit_btn" @click="setClass">确定</div>
            <div class="fai_cancel_btn" @click="reback">取消</div>
         </div>
        </div>
    </div>
   </el-dialog>
    </div>
</template>
<script>
import { getbusinessAccount,transferTeam,getAllocateList,getCurrentUser,geAccountGroup,editAccountGroup,deletAccountGroup,batchSaveAccountGroupRelation} from "@/api/enterprise/index"; // 成员列表、移交团队、已分配系统列表、成员分类列表、新增修改成员分类、删除成员分类
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'teamAdmin',
    props: {
    authType:[String, Number],//是否为组件调用 1、表示团队设置调用；2、表示分配权限调用
    },
    components:{
      paginaTion
    },
    data () {
        return {
            groupIds:[],
            checkList:[],
            groupId:1,
            textActive:0,
            options:[],
            options1:[],
            lod:false,
            centerDialogVisible:false,
            centerDialogVisible1:false,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            currentPage1: 1, //初始页
            PageSize1: 10, //每页的数据
            totalCount1:0,
            search:'',
            search1:'',
            bussID:'',
            itemList: [],
            systesList:[],
            isAdmin:'',
            currentId:'',
            propObj:{},
            catchStatus:false,
            selsctarr:[],
            multipleSelection:[],
            currentInfo:{},
            name:''
        }
    },
    created () {
     const businessInfo = this.$locaStorage.setAge().get('businessInfo')
     this.bussID = businessInfo.id
    this.getUserInfo()
    },
    methods: {
        // 批量切换分类
        setClass(){
            this.groupIds = this.multipleSelection.map(item => item.id)
            if(this.checkList.length == 0 ) return this.$util.Notifi('至少选择一个分类','error','fa-exclamation-circle') 
            let params = {
            accountIds:this.groupIds,
            businessId:this.bussID,
            groupIds:this.checkList
           }
               batchSaveAccountGroupRelation(params)
           .then(res =>{
             if(res.code == 0){
                 this.$util.Notifi('批量分类修改成功','success','fa-check')
                 this.centerDialogVisible1 = false
                 this.$refs.multipleTable.clearSelection();
                  this.getUserInfo()
             }else{
                this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
             }
           })
        },
        reback(){
            this.centerDialogVisible1 = false
        },
        // 打开修改分类窗口
        openEditClass(){
            if(this.multipleSelection.length !=0){
                this.checkList = []
                this.groupIds = []
                this.centerDialogVisible1 = true
            }else{
                 this.$util.Notifi('请先选择成员','error','fa-exclamation-circle') 
            }
        },
        // 删除分类
        deletTeamClass(id){
        this.$confirm('删除分类后不会将该组成员移出当前团队，但分类不可恢复，是否继续？', '删除分类', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            deletAccountGroup({id:id})
            .then(res =>{
                if(res.code == 0){
                     this.currentPage = 1
                     this.groupId = 1
                     this.textActive = 0
                     this.getGroup()
                    this.$util.Notifi('删除成功','success','fa-check')
                }else{
                    this.$util.Notifi('删除失败','error','fa-exclamation-circle') 
                }
            })
        }).catch(() => {          
        });
        },
        // 新建分类
        adTeamClass(name,id){
        this.$prompt('请输入成员分类名称', '添加成员分类', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern:/^[0-9a-zA-Z\u4E00-\u9FA5\uf900-\ufa2d·s]{1,50}$/,
          inputErrorMessage: '请输入1-50字符',
          inputValue:name
        }).then(({ value }) => {
         !id ? this.commonGroup(value,'post') : this.commonGroup(value,'put',id)
        }).catch(() => {      
        });
        },
        commonGroup(name,method,id){
            let params = {
                businessId:this.bussID,
                name:name,
            }
            if(id) params = {...params,id:id}
            editAccountGroup(params,method)
            .then(res =>{
                if(res.code == 0){
                   this.$util.Notifi(id?'修改成功':'添加成功','success','fa-check')
                     this.getGroup()

                }else{
                     this.$util.Notifi(res.msg,'error','fa-exclamation-circle') 
                }
            })
        },
        // 筛选切换
        swichTopic(id,index){
           if(!this.itemList.length) return this.$util.Notifi('请先等待数据加载','error','fa-exclamation-circle')
            this.currentPage = 1
            this.textActive = index
            this.groupId = id
            this.gethisList(id,index,'switch')
        },
        // 获取当前成员分类
        getGroup(){
            geAccountGroup({
                id:this.bussID,
                name:this.name,
               accountId:''
            })
            .then(res =>{
                this.options = [
                    {
                    id:'0',
                    name:'全部',
                    num:0
                },...res.data]
                this.options1 = res.data
                this.gethisList(0,0)
            })
        },
           // 获取当前用户信息
        getUserInfo(){
             getCurrentUser({
                id:this.bussID,
              },'enterprise')
            .then(res => {
            this.currentInfo = res.data.user_info
            this.isAdmin = res.data.user_info.isAdmin
            this.currentId = res.data.user_info.id
            this.getGroup()
            })
        },
         // 新增修改调用清空方法
        remove(){
           this.multipleSelection = []
        },
        // 父组件调用子组件方法
         editfun(val){
			
            this.selsctarr = val
			  console.log(this.selsctarr)
        },
               // 手动选择
    onTableSelect(rows, row){
         this.catchStatus = rows.length && rows.indexOf(row) !== -1
    },
         getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
            handleSelectionChange(val){
                this.multipleSelection = []
              let  uniqueArray = [...new Map(val.map(item => [item.id, item])).values()];
               this.multipleSelection = uniqueArray;
               console.log(this.catchStatus)
                if(this.catchStatus){
             this.multipleSelection = uniqueArray;
             let arr =  this.multipleSelection
           if(this.selsctarr && this.selsctarr.length){
              let add = this.selsctarr.filter(item=>!arr.some(ele=>ele.id===item.id)) 
			     console.log(this.selsctarr)
			                console.log(add)
            for (const key in add) {
             this.multipleSelection.push({
                    'loginName': add[key].loginName,
                    'id':add[key].id,
                    'userName':add[key].userName,
                    'accountId':add[key].accountId,
                    'businessId':add[key].businessId,
                    'authId':add[key].authId,
                    'appId':add[key].appId,
                    'allocateNum':add[key].allocateNum
                    
                })

        }
          this.multipleSelection = this.multipleSelection.filter(item => item.isAdmin); //去重，防止同一条数据出现两次
           }
                }else{
                   this.multipleSelection = uniqueArray; 
                }
           this.$emit('sendStatus', this.multipleSelection,false)
            },
        // 打开已分配系统
        openSystem(data){
            this.propObj = {}
            this.centerDialogVisible = true
            this.getSystem(data)
            this.propObj = data
        },
        getSystem(data){
             getAllocateList({id:this.bussID,accountId:data.id,size:this.PageSize1,current:this.currentPage1},'enterprise')
            .then(res =>{
               this.systesList = res.data.records
               this.totalCount1 = res.data.total
            })
        },
                       // 子组件触发
      emitFun1(val,val1){
        if(val1 == "PageSize") this.PageSize1 = val
       if(val1 == "currentPage") this.currentPage1 = val
       this.getSystem(this.propObj)
      },
        // 重置
        reset(){
            this.search = ''
            this.search1 = ''
            this.currentPage = 1
            this.gethisList(1,0)
        },
        // 新增成员
        addteamUser(){
            if(this.isAdmin == 1 || this.isAdmin == 2){
             this.$router.push('/webenterpriseManage/addteamUser')
            }else{
                this.$util.Notifi('暂无权限','error','fa-exclamation-circle') 
            }
        },
        // 设置成员分类
        userSetClass(data){
            this.$router.push({
            name:'editTeamClass',
            query:{
                parms:this.$base64.encode(JSON.stringify(data))
            }
        })
        },
        // 设置
        userSet(data){
        this.$router.push({
            name:'editTeamUser',
            query:{
                parms:this.$base64.encode(JSON.stringify(data))
            }
        })
        },
        // 移交
        swichYj(data){
            this.$confirm(`确定移交给${data.userName}`,'移交团队', {
          confirmButtonText: '移交',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
           transferTeam({businessId:this.bussID,accountId:data.id},'enterprise')
        .then(res =>{
            if(res.code == 0){
                this.$emit('sendStatus', true)
            }else{
                this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
            }
        })
        .catch(err =>{this.$util.Notifi(err.msg,'error','fa-exclamation-circle')})
        })
        },

                // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisList(this.groupId,this.textActive)
      },
          // 获取成员列表
        gethisList(id,index,type){
            this.textActive = index
            this.groupId = id
            getbusinessAccount({id:this.bussID,loginName:this.search1,userName:this.search,size:this.PageSize,current:this.currentPage,groupId:id},'enterprise',this.authType)
            .then(res =>{
                if(this.authType){
                    if(this.authType == 1){
                        this.itemList = res.data.records.filter(item=> item.id != this.currentId) 
                         this.totalCount = res.data.total -1 
                         if(id == 0)  this.options[0].num =  res.data.total -1 
                    }else if(this.authType == 2){
                         this.itemList = res.data
                       if(id == 0)  this.options[0].num = this.itemList.length
                       if(!type){
                      let rows = []
                              for (let m = 0; m < this.selsctarr.length; m++) {
                        for (let n = 0; n < this.itemList.length; n++) {
                        if (this.selsctarr[m].loginName == this.itemList[n].loginName) {
                            rows.push(this.itemList[n])
                        }
                        }
                    }
                     rows.forEach(row => {
                        console.log(row)
                        this.$refs.multipleTable.toggleRowSelection(row,true)
                    })
                       }
                    }else{
                        this.itemList = res.data.records
                         this.totalCount = res.data.total
                          if(id == 0)  this.options[0].num = res.data.total

                    }
                }else{
                  this.itemList = res.data.records || []
                  this.totalCount = res.data.total
                  if(id == 0)  this.options[0].num =  res.data.total
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.addteamUser{
    padding-top: 30px;
    font-weight: 400;
    .add_container{
     position: relative;
    margin: 0 auto;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0 7px 0 rgba(197,197,197,0.34);
    padding: 40px 105px;
    box-sizing: border-box;
    margin-bottom: 40px;
    .fai_notext_field {
    min-height: 28px;
    line-height: 28px;
    margin-bottom: 20px;
    .fai_notext_field_label{
    font-size: 12px;
    color: #90909e;
    text-align: right;
    }
    }
    .btm_btn_box{
        margin-top: 30px;    
        justify-content: center;
    .fai_submit_btn,.fai_cancel_btn,.fai_cancel_btn1{
        width: 270px;
            height: 40px;
    line-height: 40px;
    background: rgba(255,255,255,1);
    border-radius: 2px;
    box-sizing: content-box;
    font-size: 16px;
    cursor: pointer;
    transition: all .3s linear;
    text-align: center;
    }
    .fai_submit_btn{
        border: 1px solid rgba(1,87,255,1);
        color: #0157ff;
    }
    .fai_cancel_btn{
    border: 1px solid rgba(1,87,255,1);
    color: #0157ff;
    border: 1px solid #dadada;
    color: #90909e;
    margin-left: 30px;
    }
       .fai_cancel_btn1{
        border: 1px solid red;
    color: red;
    margin-left: 30px;
       }
    }
    }
}
.teamAdmin{
    width: 100%;
    padding-top: 30px;
.show_container {
    max-width: 1400px;
    min-width: 1145px;
    background: #fff;
    box-shadow: 0 0 7px 0 rgba(197,197,197,0.34);
    border-radius: 2px;
    margin: 0 auto;
    .staff_manage_head{
    height: 80px;
    line-height: 80px;
    background: rgba(246,249,255,1);
    border-radius: 2px;
    padding: 0 40px;
    .search_box{
        position: relative;
        width: 220px;
        height: 40px;
        line-height: 40px;
        background: rgba(255,255,255,1);
        border: 1px solid rgba(234,234,234,1);
        box-sizing: border-box;
         border-radius: 20px;
        .el-input{
            display: block;
            width: 100%;
            height: 100%;
            text-align: left;
            padding-left: 12px;
            box-sizing: border-box;
            color: #333;
        }
        .search_icon{
         position: absolute;
        right: 3px;
        top: 3px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: url('../../../assets/images/setting_icon.png') 0 -293px no-repeat;
        cursor: pointer;
        }
    }
    .add_btn{
    width: 129px;
    height: 38px;
    line-height: 38px;
    border-radius: 19px;
    cursor: pointer;
    background-color: #0157ff;
    color: #fff;
    font-size: 14px;
    text-align: center;
    .add_btn_icon{
     margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    line-height: 20px;
    background: url('../../../assets/images/setting_add_icon.svg') no-repeat 0 0;
    }
      .add_btn_icon1{
     margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    line-height: 20px;
    background: url('../../../assets/images/editClass.svg') no-repeat 0 0;
    background-size: 100% 100%;
    }
    }
    }
    .f-h-flex2{
        height: 700px;
        .categories-tree{
            height: inherit;
            width: 208px;
            overflow-y: auto;
            .public-add{
                height: 32px;
                line-height: 30px;
                font-size: 14px;
                padding: 0 26px;
                border-radius: 2px;
                font-family: inherit;
                border-width: 1px;
                border-style: solid;
                text-align: center;
                vertical-align: middle;
                box-sizing: border-box;
                cursor: pointer;
                transition: all 0.3s;
                background: #155bd4;
                color: #fff;
                width: 70%;
                margin: 20px auto;
            }
                  .categories-tree-item{
                position: relative;
                padding: 0 10px;
               .jstree-node:first-of-type{
                margin-top: 30px;
               }
               .treeactive{
                background: #f5fbff!important;
                border-radius: 4px;
               }
                .jstree-node{
                    cursor: pointer;
                    margin-top: 10px;
                    padding-left: 30px;
                    height: 24px;
                    .jstree-icon{
                        display: block;
                       width: 24px;
                        height: 24px;
                        line-height: 24px; 
                        background: url('../../../assets/images/tree-default.svg') no-repeat center;
                    }
                    .jstree-node-1{
                        padding-left: 12px;
                        span{
                            width: 50px;
                            display: inline-block;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }

            }
        }
        .categories-panel-dragger{
            position: relative;
    flex-shrink: 0;
    width: 16px;
    height: 100% !important;
    border-right: 1px solid #e6e6e6;
    background-color: #f2f2f2 !important;
        }
    }
    .staff_manage_center{
    position: relative;
    padding: 20px 30px 90px;
    box-sizing: border-box;
     flex-grow: 1;
        height: 100%;
        overflow: hidden;
        overflow-y: auto;
    }
}
}
@media (max-width: 1400px){
    .show_container {
     width: 1145px !important;
     margin: 0 20px !important;
    }
}
::v-deep{
      .addform{
    margin-left: 50px;
    flex-wrap: wrap;
    .el-checkbox{
        display: block !important;
        margin-bottom: 5px;
    }
    .addform-list{
        // width: 100%;
        .appname{
            line-height:35px;
        }
        .apptime{
            color: red;
        }
    }
      .el-tree-node__content{
          height: 40px !important;
      }
      .el-tree{
          display: flex;
          flex-wrap: wrap;
      }
  }
    .el-table{
        td{
            padding: 5px 0 !important;
        }
    }
    .search_box{
            .el-input__inner{
             outline: 0;
            background: 0;
            border: 0;
            box-shadow: none;
            appearance: none;
            }
            .el-input__suffix{
                right: 40px;
            }
    }
    .acBtn{
        .el-button--primary{
            background-color: #0157ff !important;
            border-radius: 20px;
            border: none;
            padding: 0;
            width: 89px;
            height: 28px;
            line-height: 28px;
            span{
                font-size: 12px;
            }
        }
    }
}
</style>